export default `
<div class="activity-feed-wrapper">
  <div profile="user" activity='activity' ng-repeat="activity in mentionsStore.feedItems" class="profile-activity-feed-item activity-{{activity.type}}" on-finish-render="ngRepeatFinished" show-extra-content="true" >
    <div class="activity-feed-content">
      <div class="profile-thumb" style="background: url({{activity.user.avatar_url}});background-size:cover;"></div>
      <div class="activity-header">
        <span>Mentioned by <a ui-sref="profile.about({profileId: activity.user.slug})">{{activity.user.name}}</a></span> on <a ng-href="{{stateStore(activity.item.commentable || activity.item)}}">{{cs.getCommentableLabel(activity.item.commentable || activity.item)}}</a>
      </div>
      <div class="time-stamp">{{activity.date | relativeDate}}</div>
    </div>
    <div class="content-extra">
      <div ng-bind-html='activity.item.content | uMarkdown | trustAsHtml'></div>
      <status-attachment ng-if="activity.item.type == 'status' && activity.item.attached_url" status="activity.item"></status-attachment>
    </div>
  </div>
  <ut-load-more (load-more)="mentionsStore.loadMore()" [is-loading]="mentionsStore.isLoading" [is-last-page]="mentionsStore.isLastPage"></ut-load-more>
</div>
`;
